import { PaginationMetadata, QuoteList } from "src/api-service";

export interface QuoteSearchState {
    results: QuoteList[];
    pagination: PaginationMetadata | null;
    loading: boolean;
}

export const initialQuoteSearchState: QuoteSearchState = {
    results: [],
    pagination: null,
    loading: false,
};
